// extracted by mini-css-extract-plugin
export const page = "privacy-policy-module--page--1DhHw";